



















import Vue from 'vue'
import { mapActions } from 'vuex'

export interface ExportModalType {
  show(name: string, onSave: (name: string) => void): void
}

export default Vue.extend({
  data () {
    return {
      showModal: false,
      exportName: '',
      onSave: (name: string) => { console.log(name) } // this is only to get the typing right. Actual implementation will be passed in
    }
  },
  watch: {
    name (name: string) {
      this.exportName = name
    },
    showModal(show: boolean) {
      // Make sure keybindings set elsewhere aren't active while we're typing into the modal
      this.setKeyBindingsActive(!show)
    }
  },
  methods: {
    ...mapActions('app', [
      'setKeyBindingsActive'
    ]),
    show(name: string, onSave: (name: string) => void) {
      this.exportName = name
      this.onSave = onSave
      this.showModal = true
      Vue.nextTick(() => this.focus())
    },
    onSubmit() {
      this.onSave(this.exportName)
      this.showModal = false
    },
    focus() {
      const input = this.$el.querySelector('input.input') as HTMLElement
      input.focus()
    }
  }
})
